import { getSession } from '../services/storage.service';

export const parseJwt = (token) => {
  const base64Url = token.split('.')[1];
  const base64 = base64Url.replace('-', '+').replace('_', '/');
  const decoded = decodeURIComponent(escape(window.atob(base64)));

  return JSON.parse(decoded);
};

const getParsedToken = () => {
  const session = getSession();

  return (session) ? parseJwt(session.token) : null;
};

export const getFirstName = () => {
  const decoded = getParsedToken() || {};

  return decoded.firstName || null;
};

export const getLastName = () => {
  const decoded = getParsedToken() || {};

  return decoded.lastName || null;
};

export const getFullName = () => {
  const firstName = getFirstName() || '';
  const lastName = getLastName() || '';

  return `${ firstName } ${ lastName }`;
};

export const getCompanyName = () => {
  const decoded = getParsedToken() || {};

  return decoded.companyName || null;
};

export const getIsReadMode = () => {
  const decoded = getParsedToken() || {};

  return decoded.isReadMode;
};

export const getIsAdmin = () => {
  const decoded = getParsedToken() || {};

  return decoded.isAdmin;
};
